/**
 * Live catalog cost rows injected by BE log fetch — never stored in activity_logs.
 * Keep id prefix in lockstep with erp_api/routes/controllers/catalogCostPriceLogs.ts.
 */

export const CATALOG_COST_LOG_ID_PREFIX = 'catalog_cost_';
export const CATALOG_COST_EVENT_TYPE = 'Catalog cost';

export const isCatalogCostPriceLogId = (id: unknown): boolean => (
  String(id || '').trim().startsWith(CATALOG_COST_LOG_ID_PREFIX)
);

export const isCatalogCostPriceLog = (log: {
  id?: unknown,
  catalogCostPrice?: unknown,
  eventType?: unknown,
  event_type?: unknown,
  message?: unknown,
  type?: unknown,
  action?: unknown,
} | null | undefined): boolean => {
  if (!log) return false;
  if (log.catalogCostPrice) return true;
  if (isCatalogCostPriceLogId(log.id)) return true;
  const event = String(log.eventType || log.event_type || '').trim();
  // Event alone is enough — do not require id (persisted / stripped shapes).
  if (event === CATALOG_COST_EVENT_TYPE) return true;
  const msg = String(log.message || '');
  if (msg.toLowerCase().includes('catalog cost')) return true;
  return false;
};
